﻿import React, { useState } from 'react';
import PendingPoliciesDataGrid from '../Components/PendingPoliciesDataGrid';
import { TopLevelFilters } from '../Components/TopLevelFilters';
import { StrikeThroughHeader } from '../../../components/Headers/strikethrough-header/strikethrough-header';
import { PoliciesSearchBar } from '../Components/PoliciesSearchBar';
import { Grid } from '@mui/material';
import { ExportButton } from '../Components/ExportButton';
import { useUser } from '../../../context/UserContext';
import Alert from '@mui/material/Alert';

function Index() {
  const [policyStatus, setPolicyStatus] = useState('All');
  const [searchText, setSearchText] = useState('');
  const [policyData, setPolicyData] = useState(null);
  const [columns, setColumns] = useState([]);
  const user = useUser();

  function policiesInfo() {
    return (
      <div>
        This only shows Policies with an Effective Date{' '}
        <span style={{ fontWeight: 'bold' }}>less than 35 days</span> from Today.
      </div>
    );
  }

  if (user.isHO === true) return <div></div>;

  return (
    <div>
      <StrikeThroughHeader>Policies</StrikeThroughHeader>
      <Grid container spacing={2}>
        <Grid style={{ textAlign: 'center' }} size={12}>
          <Alert
            severity="warning"
            color="warning"
            style={{ backgroundColor: 'rgb(255, 244, 229)' }}
          >
            {policiesInfo()}
          </Alert>
        </Grid>
        <Grid style={{ display: 'flex', margin: '0 0 1em 0' }} size={10}>
          <TopLevelFilters setPolicyStatus={setPolicyStatus} />
          <PoliciesSearchBar setSearchText={setSearchText} />
        </Grid>
        <Grid style={{ textAlign: 'right', margin: '1em 0 0 0' }} size={2}>
          <ExportButton policyData={policyData} columns={columns} />
        </Grid>
      </Grid>
      <PendingPoliciesDataGrid
        policyStatus={policyStatus}
        searchText={searchText}
        setPolicyData={setPolicyData}
        setColumns={setColumns}
      />
    </div>
  );
}
export { Index };
